import {
	ADD_ANAGRAFICA_FAIL,
	ADD_ANAGRAFICA_START,
	ADD_ANAGRAFICA_SUCCESS, ADD_NOTE_TO_DIARIO_FAIL, ADD_NOTE_TO_DIARIO_START, ADD_NOTE_TO_DIARIO_SUCCESS,
	ADD_RELAZIONE_FAIL,
	ADD_RELAZIONE_START,
	ADD_RELAZIONE_SUCCESS, GET_ALLEGATI_FAIL, GET_ALLEGATI_START, GET_ALLEGATI_SUCCESS,
	GET_ANAGRAFICA_ASSOCIATA_FAIL,
	GET_ANAGRAFICA_ASSOCIATA_START,
	GET_ANAGRAFICA_ASSOCIATA_SUCCESS,
	GET_ANAGRAFICA_FAIL,
	GET_ANAGRAFICA_START,
	GET_ANAGRAFICA_SUCCESS, GET_DIARIO_PAZIENTE_FAIL,
	GET_DIARIO_PAZIENTE_START,
	GET_DIARIO_PAZIENTE_SUCCESS,
	GET_RELAZIONI_FAIL,
	GET_RELAZIONI_START,
	GET_RELAZIONI_SUCCESS,
	RESET_ANAGRAFICA,
	SEARCH_ANAGRAFICA_FAIL,
	SEARCH_ANAGRAFICA_START,
	SEARCH_ANAGRAFICA_SUCCESS,
	SET_ANAGRAFICA, SET_DIARIO,
	UPDATE_ANAGRAFICA_FAIL,
	UPDATE_ANAGRAFICA_START,
	UPDATE_ANAGRAFICA_SUCCESS
} from "../reducers/actions/ActionTypes";
import axios from "axios";
import {
	ADD_ALLEGATO_ULR,
	ADD_ANAGRAFICA_URL, ADD_NOTE_DIARIO_URL,
	ADD_RELAZIONE_URL, GET_ALLEGATI_URL,
	GET_ANAGRAFICA_URL, GET_DIARIO_URL,
	GET_RELAZIONI_URL,
	SEARCH_ANAGRAFICA_URL,
	UPDATE_ANAGRAFICA_URL
} from "./utils/ApiUrls";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import {getConfig} from "./utils/ConfigUtils";
import {authLogout} from "./AuthServices";
import {relations} from "../utils/dictionaries/Generics";
import {getAddAllegatoData} from "./utils/ApiData";

export function getAnagraficaById(id, dispatch) {
	dispatch({type: GET_ANAGRAFICA_START});
	axios
		.get(GET_ANAGRAFICA_URL + id, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_ANAGRAFICA_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_ANAGRAFICA_FAIL, error: getErrorMessage(error)}))
}

export function resetGetAnagfrafica(dispatch) {
	dispatch({type: GET_ANAGRAFICA_START});
}

export function setAnagraficaSuccess(dispatch) {
	dispatch({type: GET_ANAGRAFICA_SUCCESS, payload: {}})
}

export function getDiario(idSoggetto, dispatch) {
	dispatch({type: GET_DIARIO_PAZIENTE_START});
	axios
		.get(GET_DIARIO_URL + idSoggetto, getConfig())
		.then((response) => {
			dispatch({type: GET_DIARIO_PAZIENTE_SUCCESS, payload: response.data})
		})
		.catch((error) => dispatch({type: GET_DIARIO_PAZIENTE_FAIL, error: getErrorMessage(error)}))
}

export function resetGetDiario(dispatch) {
	dispatch({type: GET_DIARIO_PAZIENTE_START});
}

export function getPazientiAssociati(ticketSelected, dispatch) {
	dispatch({type: GET_ANAGRAFICA_ASSOCIATA_START});
	axios
		.get(GET_RELAZIONI_URL + ticketSelected.idSoggetto, getConfig())
		.then((response) => {
			dispatch({type: GET_ANAGRAFICA_ASSOCIATA_SUCCESS, payload: response.data});
		})
		.catch((error) => dispatch({type: GET_ANAGRAFICA_ASSOCIATA_FAIL, error: getErrorMessage(error)}))
}

export function searchAnagrafica(anagrafica, dispatch) {
	dispatch({type: SEARCH_ANAGRAFICA_START});
	axios
		.post(SEARCH_ANAGRAFICA_URL, anagrafica, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: SEARCH_ANAGRAFICA_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: SEARCH_ANAGRAFICA_FAIL, error: getErrorMessage(error)}))
}

export function updateAnagrafica(anagrafica, idSoggetto, dispatch) {
	dispatch({type: UPDATE_ANAGRAFICA_START});
	axios
		.post(UPDATE_ANAGRAFICA_URL + idSoggetto, anagrafica, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: UPDATE_ANAGRAFICA_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: UPDATE_ANAGRAFICA_FAIL, error: getErrorMessage(error)}))
}

export function resetGetAnagrafica(dispatch) {
	dispatch({type: GET_ANAGRAFICA_START});
}

export function addAnagrafica(anagrafica, dispatch) {
	dispatch({type: ADD_ANAGRAFICA_START});
	axios
		.post(ADD_ANAGRAFICA_URL, anagrafica, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: ADD_ANAGRAFICA_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => {
			let message = getErrorMessage(error);
			if (message.includes("Anagrafica già esistente")) {
				let id = parseInt(message.replace(/\D/g, ''));
				getAnagraficaById(id, dispatch);
			} else {
				dispatch({type: ADD_ANAGRAFICA_FAIL, error: message})
			}
		})
}

export function resetAnagraficaLoading(dispatch) {
	dispatch({type: RESET_ANAGRAFICA});
}

export function setAnagrafica(anagrafica, dispatch) {
	dispatch({type: SET_ANAGRAFICA, payload: anagrafica});
}

export function getAllRelazioniBySoggetto(idSoggetto, dispatch) {
	dispatch({type: GET_RELAZIONI_START});
	axios
		.get(GET_RELAZIONI_URL + idSoggetto, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_RELAZIONI_SUCCESS, payload: response.data, map: {[idSoggetto]: response.data}})
			}
		})
		.catch((error) => dispatch({type: GET_RELAZIONI_FAIL, error: getErrorMessage(error)}))
}

export function addRelazione(idSrc, idDst, type, dispatch) {
	dispatch({type: ADD_RELAZIONE_START})
	axios
		.post(ADD_RELAZIONE_URL + idSrc + "/" + idDst + "/" + type, {
			src: idSrc,
			dst: idDst,
			type: type
		}, getConfig())
		.then(() => {
			axios
				.post(ADD_RELAZIONE_URL + idDst + "/" + idSrc + "/" + relations[type], {
					src: idDst,
					dst: idSrc,
					type: relations[type]
				}, getConfig())
				.then(() => dispatch({type: ADD_RELAZIONE_SUCCESS}))
		})
		.catch((error) => dispatch({type: ADD_RELAZIONE_FAIL, error: getErrorMessage(error)}))
}

export function addNoteToDiario(data, idSoggetto, dispatch) {
	dispatch({type: ADD_NOTE_TO_DIARIO_START});
	axios
		.post(ADD_NOTE_DIARIO_URL + idSoggetto, data, getConfig())
		.then(() => dispatch({type: ADD_NOTE_TO_DIARIO_SUCCESS}))
		.catch((error) => dispatch({type: ADD_NOTE_TO_DIARIO_FAIL, error: getErrorMessage(error)}))
}

export function addAllegatoToUser(data, idSoggetto, dispatch) {
	if (data.allegato) {
		data.allegato.forEach(allegato => {
			axios
				.post(ADD_ALLEGATO_ULR + "/" + idSoggetto, getAddAllegatoData(allegato))
				.then(() => getAllegatiBySoggetto(idSoggetto, dispatch))
				.catch((error) => alert(getErrorMessage(error)));
		})
	} else {
		alert("Ops, non hai caricato nessun allegato...")
	}
}

export function getAllegatiBySoggetto(idSoggetto, dispatch) {
	dispatch({type: GET_ALLEGATI_START});
	axios
		.get(GET_ALLEGATI_URL + idSoggetto, getConfig())
		.then((response) => dispatch({type: GET_ALLEGATI_SUCCESS, payload: response.data}))
		.catch((error) => dispatch({type: GET_ALLEGATI_FAIL, error: getErrorMessage(error)}))
}

export function setDiario(diario, dispatch) {
	dispatch({type: SET_DIARIO, payload: diario});
}
